/* eslint-disable import/no-anonymous-default-export */
import { Action } from "../../../domain/entities/ActionModel";
import { ConfigPageIndex, SiteImage } from "../../../domain/entities/Configs";
import Organization from "../../../domain/entities/Organization";
import {
    AdministratorState,
    StateStatus,
} from "../../../domain/entities/State";
import User from "../../../domain/entities/User";
import { ActionTypes } from "../actions/administrator";

const initialState: AdministratorState = {
  organizationsLoadStatus: StateStatus.INIT,
  organizations: [],
  organizationsLoadError: undefined,
  organizationSave: StateStatus.INIT,
  organizationSaveError: undefined,
  organizationIdStatus: StateStatus.INIT,
  organizationLoadStatus: StateStatus.INIT,
  organization: undefined,
  organizationLoadError: undefined,
  organizationDeleteError: undefined,
  organizationDeleteStatus: undefined,
  permissionsLoadStatus: StateStatus.INIT,
  permissions: [],
  permissionsLoadError: undefined,
  permissionTypesLoadStatus: StateStatus.INIT,
  permissionTypes: [],
  permissionTypesLoadError: undefined,
  permissionSaveStatus: StateStatus.INIT,
  permissionSaveError: undefined,
  rolesLoadStatus: StateStatus.INIT,
  roles: [],
  rolesLoadError: undefined,
  usersLoadStatus: StateStatus.INIT,
  user: null,
  userLoadStatus: StateStatus.INIT,
  userLoadError: undefined,
  users: [],
  usersLoadError: undefined,
  userSaved: null,
  userSaveStatus: StateStatus.INIT,
  userSaveError: undefined,
  userCognitoSaveStatus: StateStatus.INIT,
  userCognitoCheckStatus: StateStatus.INIT,
  userCognitoSaveError: undefined,
  userCognitoExists: false,
  userDeleteStatus: StateStatus.INIT,
  userDeleteError: undefined,
  userRegisterStatus: StateStatus.INIT,
  userRegisterError: undefined,
  siteConfigs: undefined,
  siteConfigsError: undefined,
  siteConfigsLoad: undefined,
  siteConfigsSave: undefined,
  siteImages: undefined,
  userOrgs: undefined,
  userOrgsLoadStatus: StateStatus.INIT,
  userOrgsLoadError: undefined,
  shapefilesLoadStatus: StateStatus.INIT,
  shapefiles: [],
  shapefilesLoadError: undefined,
  shapefileSaveStatus: StateStatus.INIT,
  shapefileSaveError: undefined,
  shapefileDeleteStatus: StateStatus.INIT,
  shapefileDeleteError: undefined,
  seatLimitConfigsLoadStatus: StateStatus.INIT,
  seatLimitConfigs: [],
  seatLimitConfigsLoadError: undefined,
  seatLimitConfigSaveStatus: StateStatus.INIT,
  seatLimitConfigSaveError: undefined,
  classroomSizeConfigsLoadStatus: StateStatus.INIT,
  classroomSizeConfigs: [],
  classroomSizeConfigsLoadError: undefined,
  classroomSizeConfigSaveStatus: StateStatus.INIT,
  classroomSizeConfigSaveError: undefined,
  feederPatternConfigsLoadStatus: StateStatus.INIT,
  feederPatternConfigs: [],
  feederPatternConfigsLoadError: undefined,
  feederPatternConfigSaveStatus: StateStatus.INIT,
  feederPatternConfigSaveError: undefined,
  feederPatternConfigDeleteStatus: StateStatus.INIT,
  feederPatternConfigDeleteError: undefined,
  feederPatternConfigImportStatus: StateStatus.INIT,
  feederPatternConfigImportError: undefined,
  schoolDirectoryLoadStatus: StateStatus.INIT,
  schoolDirectory: [],
  schoolDirectoryLoadError: undefined,
  schoolDirectorySaveStatus: StateStatus.INIT,
  schoolDirectorySaveError: undefined,
  schoolDirectoryBatchSaveStatus: StateStatus.INIT,
  schoolDirectoryBatchSaveError: undefined,
  schoolDirectoryDeleteStatus: StateStatus.INIT,
  schoolDirectoryDeleteError: undefined,
  programCodesLoadStatus: StateStatus.INIT,
  programCodes: {},
  programCodesLoadError: undefined,
  programCodesSaveStatus: StateStatus.INIT,
  programCodesSaveError: undefined,
};

export default (
  state = initialState,
  action: Action<any>
): AdministratorState => {
  switch (action.type) {
    case ActionTypes.ORGANIZATIONS_LOAD_COMPLETE: {
      return {
        ...state,
        organizationsLoadStatus: StateStatus.COMPLETE,
        organizations: action.payload,
        organizationsLoadError: null,
      };
    }
    case ActionTypes.ORGANIZATIONS_LOAD_ERROR: {
      return {
        ...state,
        organizationsLoadStatus: StateStatus.ERROR,
        organizationsLoadError: action.payload,
      };
    }
    case ActionTypes.ORGANIZATIONS_LOAD_PROCESSING: {
      return {
        ...state,
        organizationsLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.ORGANIZATIONS_SAVE_COMPLETE: {
      return {
        ...state,
        organizationSave: StateStatus.COMPLETE,
        //organizations: action.payload,
        organizationSaveError: undefined,
      };
    }
    case ActionTypes.ORGANIZATIONS_SAVE_ERROR: {
      return {
        ...state,
        organizationSave: StateStatus.ERROR,
        organizationSaveError: action.payload,
      };
    }
    case ActionTypes.ORGANIZATIONS_SAVE_PROCESSING: {
      return {
        ...state,
        organizationSave: StateStatus.LOADING,
      };
    }
    case ActionTypes.ORGANIZATIONS_GET_BYURL_COMPLETE: {
      return {
        ...state,
        organizationIdStatus: StateStatus.COMPLETE,
        organization: action.payload,
      };
    }
    case ActionTypes.ORGANIZATION_GET_ERROR: {
      return {
        ...state,
        organizationLoadError: action.payload,
        organizationLoadStatus: StateStatus.ERROR,
      };
    }
    case ActionTypes.ORGANIZATION_GET_PROCESSING: {
      return {
        ...state,
        organizationLoadError: undefined,
        organizationLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.ORGANIZATION_GET_COMPLETE: {
      return {
        ...state,
        organization: action.payload,
        organizationLoadError: undefined,
        organizationLoadStatus: StateStatus.COMPLETE,
      };
    }
    case ActionTypes.ORGANIZATION_GET_LOGIN_ERROR: {
      return {
        ...state,
        userOrgs: undefined,
        userOrgsLoadError: action.payload,
        userOrgsLoadStatus: StateStatus.ERROR,
      };
    }
    case ActionTypes.ORGANIZATION_GET_LOGIN_PROCESSING: {
      return {
        ...state,
        userOrgs: undefined,
        userOrgsLoadError: undefined,
        userOrgsLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.ORGANIZATION_GET_LOGIN_COMPLETE: {
      const loggedUserArray: User[] = action.payload.loggedUserArray;
      const orgDetails: Organization = action.payload.orgDetails;

      /**
       * FIX: Replace organization tree with fresh data from backend
       * 
       * The orgDetails contains the complete, up-to-date organization tree including
       * any newly added child organizations. We replace the organization field of 
       * each user with this fresh data.
       * 
       * Note: Organizations.tsx will also update localStorage after this dispatch completes,
       * ensuring both Redux and localStorage stay in sync.
       */
      const updatedUserArray = loggedUserArray.map((user) => ({
        ...user,
        organization: orgDetails
      }));

      return {
        ...state,
        userOrgs: updatedUserArray,
        userOrgsLoadError: undefined,
        userOrgsLoadStatus: StateStatus.COMPLETE,
      };
    }
    case ActionTypes.ORGANIZATION_DELETE_ERROR: {
      return {
        ...state,
        organizationDeleteError: action.payload,
        organizationDeleteStatus: StateStatus.ERROR,
      };
    }
    case ActionTypes.ORGANIZATION_DELETE_PROCESSING: {
      return {
        ...state,
        organizationDeleteError: undefined,
        organizationDeleteStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.ORGANIZATION_DELETE_COMPLETE: {
      return {
        ...state,
        organizationDeleteError: undefined,
        organizationDeleteStatus: StateStatus.COMPLETE,
      };
    }
    case ActionTypes.PERMISSIONS_LOAD_COMPLETE: {
      return {
        ...state,
        permissionsLoadStatus: StateStatus.COMPLETE,
        permissions: action.payload,
        permissionsLoadError: null,
      };
    }
    case ActionTypes.PERMISSIONS_LOAD_ERROR: {
      return {
        ...state,
        permissionsLoadStatus: StateStatus.ERROR,
        permissionsLoadError: action.payload,
      };
    }
    case ActionTypes.PERMISSIONS_LOAD_PROCESSING: {
      return {
        ...state,
        permissionsLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.PERMISSIONTYPES_LOAD_COMPLETE: {
      return {
        ...state,
        permissionTypesLoadStatus: StateStatus.COMPLETE,
        permissionTypes: action.payload,
        permissionTypesLoadError: null,
      };
    }
    case ActionTypes.PERMISSIONTYPES_LOAD_ERROR: {
      return {
        ...state,
        permissionTypesLoadStatus: StateStatus.ERROR,
        permissionTypesLoadError: action.payload,
      };
    }
    case ActionTypes.PERMISSIONTYPES_LOAD_PROCESSING: {
      return {
        ...state,
        permissionTypesLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.PERMISSION_SAVE_COMPLETE: {
      return {
        ...state,
        permissionSaveStatus: StateStatus.COMPLETE,
        permissionSaveError: null,
      };
    }
    case ActionTypes.PERMISSION_SAVE_ERROR: {
      return {
        ...state,
        permissionSaveStatus: StateStatus.ERROR,
        permissionSaveError: action.payload,
      };
    }
    case ActionTypes.PERMISSION_SAVE_PROCESSING: {
      return {
        ...state,
        permissionSaveStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.ROLES_LOAD_COMPLETE: {
      return {
        ...state,
        rolesLoadStatus: StateStatus.COMPLETE,
        roles: action.payload,
        rolesLoadError: null,
      };
    }
    case ActionTypes.ROLES_LOAD_ERROR: {
      return {
        ...state,
        rolesLoadStatus: StateStatus.ERROR,
        rolesLoadError: action.payload,
      };
    }
    case ActionTypes.ROLES_LOAD_PROCESSING: {
      return {
        ...state,
        rolesLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.USER_LOAD_BY_EMAIL_COMPLETE: {
      return {
        ...state,
        userLoadStatus: StateStatus.COMPLETE,
        user: action.payload,
        userLoadError: null,
      };
    }
    case ActionTypes.USER_LOAD_BY_EMAIL_ERROR: {
      return {
        ...state,
        userLoadStatus: StateStatus.ERROR,
        userLoadError: action.payload,
      };
    }
    case ActionTypes.USER_LOAD_BY_EMAIL_PROCESSING: {
      return {
        ...state,
        userLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.USERS_LOAD_COMPLETE: {
      return {
        ...state,
        usersLoadStatus: StateStatus.COMPLETE,
        users: action.payload,
        usersLoadError: null,
      };
    }
    case ActionTypes.USERS_LOAD_ERROR: {
      return {
        ...state,
        usersLoadStatus: StateStatus.ERROR,
        usersLoadError: action.payload,
      };
    }
    case ActionTypes.USERS_LOAD_PROCESSING: {
      return {
        ...state,
        usersLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.USER_SAVE_COMPLETE: {
      return {
        ...state,
        userSaveStatus: StateStatus.COMPLETE,
        userSaveError: null,
        userSaved: action.payload,
      };
    }
    case ActionTypes.USER_SAVE_ERROR: {
      return {
        ...state,
        userSaveStatus: StateStatus.ERROR,
        userSaveError: action.payload,
      };
    }
    case ActionTypes.USER_SAVE_PROCESSING: {
      return {
        ...state,
        userSaveStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.USER_COGNITO_SAVE_COMPLETE: {
      return {
        ...state,
        userCognitoSaveStatus: StateStatus.COMPLETE,
        userCognitoSaveError: null,
      };
    }
    case ActionTypes.USER_COGNITO_SAVE_PROCESSING: {
      return {
        ...state,
        userCognitoSaveStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.USER_COGNITO_SAVE_ERROR: {
      return {
        ...state,
        userCognitoSaveStatus: StateStatus.ERROR,
        userCognitoSaveError: action.payload,
      };
    }
    case ActionTypes.COGNITO_USER_CHECK_PROCESSING: {
      return {
        ...state,
        userCognitoCheckStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.COGNITO_USER_CHECK_COMPLETE: {
      return {
        ...state,
        userCognitoCheckStatus: StateStatus.COMPLETE, 
        userCognitoExists: action.payload,
      };
    }
    case ActionTypes.COGNITO_USER_CHECK_ERROR: {
      return {
        ...state,
        userCognitoCheckStatus: StateStatus.ERROR, 
      };
    }

    case ActionTypes.USER_DELETE_COMPLETE: {
      return {
        ...state,
        userDeleteStatus: StateStatus.COMPLETE,
        userDeleteError: null,
      };
    }
    case ActionTypes.USER_DELETE_ERROR: {
      return {
        ...state,
        userDeleteStatus: StateStatus.ERROR,
        userDeleteError: action.payload,
      };
    }
    case ActionTypes.USER_DELETE_PROCESSING: {
      return {
        ...state,
        userDeleteStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.USER_REGISTER_COMPLETE: {
      return {
        ...state,
        userRegisterStatus: StateStatus.COMPLETE,
        userRegisterError: null,
      };
    }
    case ActionTypes.USER_REGISTER_ERROR: {
      return {
        ...state,
        userRegisterStatus: StateStatus.ERROR,
        userRegisterError: action.payload,
      };
    }
    case ActionTypes.USER_REGISTER_PROCESSING: {
      return {
        ...state,
        userRegisterStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.CONFIGS_LOAD_PROCESSING: {
      return {
        ...state,
        //siteConfigs: undefined,
        siteConfigsLoad: StateStatus.LOADING,
      };
    }
    case ActionTypes.CONFIGS_LOAD_COMPLETE: {
      const page: ConfigPageIndex = action.payload.page;
      const newData = action.payload.config || {};
      const siteConfigs = { ...state.siteConfigs };

      if (page === ConfigPageIndex.CONFIGURATIONS) {
        siteConfigs.siteConfigs = newData;
      }
      if (page === ConfigPageIndex.EMAIL_TEMPL) {
        siteConfigs.emailTemplates = newData;
      }
      if (page === ConfigPageIndex.CLEVER_CONFIG) {
        siteConfigs.cleverConfig = newData;
      }
      if (page === ConfigPageIndex.PAISLEY_CONFIG) {
        siteConfigs.paisleyConfig = newData;
      }

      return {
        ...state,
        siteConfigsLoad: StateStatus.COMPLETE,
        siteConfigs: siteConfigs,
      };
    }
    case ActionTypes.CONFIGS_LOAD_ERROR: {
      return {
        ...state,
        // siteConfigs: undefined,
        siteConfigsLoad: StateStatus.ERROR,
        siteConfigsError: action.payload,
      };
    }
    case ActionTypes.FATHER_CONFIGS_LOAD_PROCESSING: {
      return {
        ...state,
        //siteConfigs: undefined,
        fatherSiteConfigsLoad: StateStatus.LOADING,
      };
    }
    case ActionTypes.FATHER_CONFIGS_LOAD_COMPLETE: {
      const page: ConfigPageIndex = action.payload.page;
      const newData = action.payload.config;
      let fatherSiteConfigs = state.fatherSiteConfigs;

      fatherSiteConfigs = { ...fatherSiteConfigs };
      if (page === ConfigPageIndex.CONFIGURATIONS) {
        fatherSiteConfigs!.siteConfigs = newData;
      }
      if (page === ConfigPageIndex.EMAIL_TEMPL) {
        fatherSiteConfigs!.emailTemplates = newData;
      }
      if (page === ConfigPageIndex.CLEVER_CONFIG) {
        fatherSiteConfigs!.cleverConfig = newData;
      }

      return {
        ...state,
        fatherSiteConfigsLoad: StateStatus.COMPLETE,
        fatherSiteConfigs: fatherSiteConfigs,
      };
    }
    case ActionTypes.FATHER_CONFIGS_LOAD_ERROR: {
      return {
        ...state,
        fatherSiteConfigs: undefined,
        fatherSiteConfigsLoad: StateStatus.ERROR,
        fatherSiteConfigsError: action.payload,
      };
    }
    case ActionTypes.CONFIGS_SAVE_COMPLETE: {
      const page: ConfigPageIndex = action.payload.page;
      const newData = action.payload.config;
      const siteConfigs = { ...state.siteConfigs };

      if (page === ConfigPageIndex.CONFIGURATIONS) {
        siteConfigs.siteConfigs = newData;
      }
      if (page === ConfigPageIndex.EMAIL_TEMPL) {
        siteConfigs.emailTemplates = newData;
      }
      if (page === ConfigPageIndex.CLEVER_CONFIG) {
        siteConfigs.cleverConfig = newData;
      }
      return {
        ...state,
        siteConfigsSave: StateStatus.COMPLETE,
        siteConfigs: siteConfigs,
        //siteConfigs: { ...state.siteConfigs, siteConfigs: action.payload },
      };
    }
    case ActionTypes.CONFIGS_SAVE_ERROR: {
      return {
        ...state,
        siteConfigs: undefined,
        siteConfigsSave: StateStatus.ERROR,
        siteConfigsError: action.payload,
      };
    }
    case ActionTypes.CONFIGS_IMAGE_SAVE_COMPLETE: {
      const localImageUrl = window.URL.createObjectURL(action.payload.file);

      let newSiteImage: SiteImage = {
        ...state.siteImages,
        [action.payload.fileName]: localImageUrl,
      };
      return {
        ...state,
        siteImages: newSiteImage,
      };
    }
    case ActionTypes.CONFIGS_IMAGE_GET_COMPLETE: {
      const localImageUrl = window.URL.createObjectURL(action.payload.file);

      let newSiteImage: SiteImage = {
        ...state.siteImages,
        [action.payload.fileName]: localImageUrl,
      };

      return {
        ...state,
        siteImages: newSiteImage,
      };
    }
    case ActionTypes.SHAPEFILE_SAVE_COMPLETE: {
      return {
        ...state,
        shapefileSaveStatus: StateStatus.COMPLETE,
        shapefileSaveError: null,
      };
    }
    case ActionTypes.SHAPEFILE_SAVE_ERROR: {
      return {
        ...state,
        shapefileSaveStatus: StateStatus.ERROR,
        shapefileSaveError: action.payload,
      };
    }
    case ActionTypes.SHAPEFILE_SAVE_PROCESSING: {
      return {
        ...state,
        shapefileSaveStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.SHAPEFILES_LOAD_COMPLETE: {
      return {
        ...state,
        shapefilesLoadStatus: StateStatus.COMPLETE,
        shapefiles: action.payload,
        shapefilesLoadError: null,
      };
    }
    case ActionTypes.SHAPEFILES_LOAD_ERROR: {
      return {
        ...state,
        shapefilesLoadStatus: StateStatus.ERROR,
        shapefilesLoadError: action.payload,
      };
    }
    case ActionTypes.SHAPEFILES_LOAD_PROCESSING: {
      return {
        ...state,
        shapefilesLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.SHAPEFILE_DELETE_COMPLETE: {
      return {
        ...state,
        shapefileDeleteStatus: StateStatus.COMPLETE,
        shapefileDeleteError: null,
      };
    }
    case ActionTypes.SHAPEFILE_DELETE_ERROR: {
      return {
        ...state,
        shapefileDeleteStatus: StateStatus.ERROR,
        shapefileDeleteError: action.payload,
      };
    }
    case ActionTypes.SHAPEFILE_DELETE_PROCESSING: {
      return {
        ...state,
        shapefileDeleteStatus: StateStatus.LOADING,
      };
    }
        case ActionTypes.SEAT_LIMIT_CONFIG_SAVE_COMPLETE: {
      return {
        ...state,
        seatLimitConfigSaveStatus: StateStatus.COMPLETE,
        seatLimitConfigSaveError: null,
      };
    }
    case ActionTypes.SEAT_LIMIT_CONFIG_SAVE_ERROR: {
      return {
        ...state,
        seatLimitConfigSaveStatus: StateStatus.ERROR,
        seatLimitConfigSaveError: action.payload,
      };
    }
    case ActionTypes.SEAT_LIMIT_CONFIG_SAVE_PROCESSING: {
      return {
        ...state,
        seatLimitConfigSaveStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.SEAT_LIMIT_CONFIGS_LOAD_COMPLETE: {
      return {
        ...state,
        seatLimitConfigsLoadStatus: StateStatus.COMPLETE,
        seatLimitConfigs: action.payload,
        seatLimitConfigsLoadError: null,
      };
    }
    case ActionTypes.SEAT_LIMIT_CONFIGS_LOAD_ERROR: {
      return {
        ...state,
        seatLimitConfigsLoadStatus: StateStatus.ERROR,
        seatLimitConfigsLoadError: action.payload,
      };
    }
    case ActionTypes.SEAT_LIMIT_CONFIGS_LOAD_PROCESSING: {
      return {
        ...state,
        seatLimitConfigsLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.CLASSROOM_SIZE_CONFIG_SAVE_COMPLETE: {
      return {
        ...state,
        classroomSizeConfigSaveStatus: StateStatus.COMPLETE,
        classroomSizeConfigSaveError: null,
      };
    }
    case ActionTypes.CLASSROOM_SIZE_CONFIG_SAVE_ERROR: {
      return {
        ...state,
        classroomSizeConfigSaveStatus: StateStatus.ERROR,
        classroomSizeConfigSaveError: action.payload,
      };
    }
    case ActionTypes.CLASSROOM_SIZE_CONFIG_SAVE_PROCESSING: {
      return {
        ...state,
        classroomSizeConfigSaveStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.CLASSROOM_SIZE_CONFIGS_LOAD_COMPLETE: {
      return {
        ...state,
        classroomSizeConfigsLoadStatus: StateStatus.COMPLETE,
        classroomSizeConfigs: action.payload,
        classroomSizeConfigsLoadError: null,
      };
    }
    case ActionTypes.CLASSROOM_SIZE_CONFIGS_LOAD_ERROR: {
      return {
        ...state,
        classroomSizeConfigsLoadStatus: StateStatus.ERROR,
        classroomSizeConfigsLoadError: action.payload,
      };
    }
    case ActionTypes.CLASSROOM_SIZE_CONFIGS_LOAD_PROCESSING: {
      return {
        ...state,
        classroomSizeConfigsLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.FEEDER_PATTERN_CONFIG_SAVE_COMPLETE: {
      return {
        ...state,
        feederPatternConfigSaveStatus: StateStatus.COMPLETE,
        feederPatternConfigSaveError: null,
      };
    }
    case ActionTypes.FEEDER_PATTERN_CONFIG_SAVE_ERROR: {
      return {
        ...state,
        feederPatternConfigSaveStatus: StateStatus.ERROR,
        feederPatternConfigSaveError: action.payload,
      };
    }
    case ActionTypes.FEEDER_PATTERN_CONFIG_SAVE_PROCESSING: {
      return {
        ...state,
        feederPatternConfigSaveStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.FEEDER_PATTERN_CONFIGS_LOAD_COMPLETE: {
      return {
        ...state,
        feederPatternConfigsLoadStatus: StateStatus.COMPLETE,
        feederPatternConfigs: action.payload,
        feederPatternConfigsLoadError: null,
      };
    }
    case ActionTypes.FEEDER_PATTERN_CONFIGS_LOAD_ERROR: {
      return {
        ...state,
        feederPatternConfigsLoadStatus: StateStatus.ERROR,
        feederPatternConfigsLoadError: action.payload,
      };
    }
    case ActionTypes.FEEDER_PATTERN_CONFIGS_LOAD_PROCESSING: {
      return {
        ...state,
        feederPatternConfigsLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.FEEDER_PATTERN_CONFIG_DELETE_COMPLETE: {
      return {
        ...state,
        feederPatternConfigDeleteStatus: StateStatus.COMPLETE,
        feederPatternConfigs: state.feederPatternConfigs.filter(
          (config) => config.id !== action.payload
        ),
        feederPatternConfigDeleteError: null,
      };
    }
    case ActionTypes.FEEDER_PATTERN_CONFIG_DELETE_ERROR: {
      return {
        ...state,
        feederPatternConfigDeleteStatus: StateStatus.ERROR,
        feederPatternConfigDeleteError: action.payload,
      };
    }
    case ActionTypes.FEEDER_PATTERN_CONFIG_DELETE_PROCESSING: {
      return {
        ...state,
        feederPatternConfigDeleteStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.FEEDER_PATTERN_CONFIG_IMPORT_COMPLETE: {
      return {
        ...state,
        feederPatternConfigImportStatus: StateStatus.COMPLETE,
        feederPatternConfigImportError: null,
      };
    }
    case ActionTypes.FEEDER_PATTERN_CONFIG_IMPORT_ERROR: {
      return {
        ...state,
        feederPatternConfigImportStatus: StateStatus.ERROR,
        feederPatternConfigImportError: action.payload,
      };
    }
    case ActionTypes.FEEDER_PATTERN_CONFIG_IMPORT_PROCESSING: {
      return {
        ...state,
        feederPatternConfigImportStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.SCHOOL_DIRECTORY_LOAD_COMPLETE: {
      return {
        ...state,
        schoolDirectoryLoadStatus: StateStatus.COMPLETE,
        schoolDirectory: action.payload,
        schoolDirectoryLoadError: null,
      };
    }
    case ActionTypes.SCHOOL_DIRECTORY_LOAD_ERROR: {
      return {
        ...state,
        schoolDirectoryLoadStatus: StateStatus.ERROR,
        schoolDirectoryLoadError: action.payload,
      };
    }
    case ActionTypes.SCHOOL_DIRECTORY_LOAD_PROCESSING: {
      return {
        ...state,
        schoolDirectoryLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.SCHOOL_DIRECTORY_SAVE_COMPLETE: {
      const saved = action.payload;
      const idx = state.schoolDirectory.findIndex(e => e.schoolId === saved.schoolId);
      const updated = [...state.schoolDirectory];
      if (idx >= 0) {
        updated[idx] = saved;
      } else {
        updated.push(saved);
      }
      return {
        ...state,
        schoolDirectorySaveStatus: StateStatus.COMPLETE,
        schoolDirectory: updated,
        schoolDirectorySaveError: null,
      };
    }
    case ActionTypes.SCHOOL_DIRECTORY_SAVE_ERROR: {
      return {
        ...state,
        schoolDirectorySaveStatus: StateStatus.ERROR,
        schoolDirectorySaveError: action.payload,
      };
    }
    case ActionTypes.SCHOOL_DIRECTORY_SAVE_PROCESSING: {
      return {
        ...state,
        schoolDirectorySaveStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.SCHOOL_DIRECTORY_BATCH_SAVE_COMPLETE: {
      return {
        ...state,
        schoolDirectoryBatchSaveStatus: StateStatus.COMPLETE,
        schoolDirectoryBatchSaveError: null,
      };
    }
    case ActionTypes.SCHOOL_DIRECTORY_BATCH_SAVE_ERROR: {
      return {
        ...state,
        schoolDirectoryBatchSaveStatus: StateStatus.ERROR,
        schoolDirectoryBatchSaveError: action.payload,
      };
    }
    case ActionTypes.SCHOOL_DIRECTORY_BATCH_SAVE_PROCESSING: {
      return {
        ...state,
        schoolDirectoryBatchSaveStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.SCHOOL_DIRECTORY_DELETE_COMPLETE: {
      return {
        ...state,
        schoolDirectoryDeleteStatus: StateStatus.COMPLETE,
        schoolDirectory: state.schoolDirectory.filter(e => e.schoolId !== action.payload),
        schoolDirectoryDeleteError: null,
      };
    }
    case ActionTypes.SCHOOL_DIRECTORY_DELETE_ERROR: {
      return {
        ...state,
        schoolDirectoryDeleteStatus: StateStatus.ERROR,
        schoolDirectoryDeleteError: action.payload,
      };
    }
    case ActionTypes.SCHOOL_DIRECTORY_DELETE_PROCESSING: {
      return {
        ...state,
        schoolDirectoryDeleteStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.PROGRAM_CODES_LOAD_PROCESSING: {
      return {
        ...state,
        programCodesLoadStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.PROGRAM_CODES_LOAD_COMPLETE: {
      const payload = action.payload;
      // an org with no saved overrides gets an empty/absent config back
      const codes =
        payload && typeof payload === "object" && !Array.isArray(payload)
          ? payload
          : {};
      return {
        ...state,
        programCodesLoadStatus: StateStatus.COMPLETE,
        programCodes: codes,
        programCodesLoadError: null,
      };
    }
    case ActionTypes.PROGRAM_CODES_LOAD_ERROR: {
      return {
        ...state,
        programCodesLoadStatus: StateStatus.ERROR,
        programCodesLoadError: action.payload,
      };
    }
    case ActionTypes.PROGRAM_CODES_SAVE_PROCESSING: {
      return {
        ...state,
        programCodesSaveStatus: StateStatus.LOADING,
      };
    }
    case ActionTypes.PROGRAM_CODES_SAVE_COMPLETE: {
      const payload = action.payload;
      const codes =
        payload && typeof payload === "object" && !Array.isArray(payload)
          ? payload
          : {};
      return {
        ...state,
        programCodesSaveStatus: StateStatus.COMPLETE,
        programCodes: codes,
        programCodesSaveError: null,
      };
    }
    case ActionTypes.PROGRAM_CODES_SAVE_ERROR: {
      return {
        ...state,
        programCodesSaveStatus: StateStatus.ERROR,
        programCodesSaveError: action.payload,
      };
    }
    default:
      return state;
  }
};
